import { combineReducers } from "redux";
import { walletReducer } from "./Wallet";
import { adminPanelReducer } from "./AdminPanel";
import { stakeReducer } from "./Stake";
import { securityReducer } from "./security";
import { phaseReducer } from "./Phase";
import { txhashReducer } from "./Tx";
import { purchaseReducer } from "./Purchase";
import { kycReducer } from "./KYC";
import { projectsReducer } from "./Projects";
import { usersReducer } from "./Users";
import { bankaccountsReducer } from "./BankAccounts";
import { paymentsReducer } from "./Payments";
import { stripeReducer } from "./Stripe";

export const rootReducer = combineReducers({
  wallet: walletReducer,
  adminPanel: adminPanelReducer,
  stake: stakeReducer,
  security: securityReducer,
  phase: phaseReducer,
  txhash: txhashReducer,
  purchase: purchaseReducer,
  kyc: kycReducer,
  projects: projectsReducer,
  users: usersReducer,
  bankaccounts: bankaccountsReducer,
  payments: paymentsReducer,
  stripe: stripeReducer,
});
